/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * DynamicCloud Backstage API V1
 * API Backstage
 * OpenAPI spec version: v1
 */

export type LinkTarget = typeof LinkTarget[keyof typeof LinkTarget];


export const LinkTarget = {
  NEWTAB: 'NEWTAB',
  NAVIGATIONIFRAME: 'NAVIGATIONIFRAME',
  CONTENTIFRAME: 'CONTENTIFRAME',
} as const;
